<template>
  <div :class='classes'>
    <w-inline-title v-if='withAdressTitle === true'>
      <slot name='title'>
        {{ $t('Common.address') }}
      </slot>
    </w-inline-title>
    <slot
      name='prepend'
      :value-handed-and-filled='valueHandedAndFilled'
    />
    <w-row v-if='showCompanyField'>
      <w-column>
        <label>{{ company }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showFullnameField'>
      <w-column>
        <label>{{ fullname }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showSupplementField'>
      <w-column cols='auto'>
        <label>{{ supplement }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showStreetField || showHouseNumberField'>
      <w-column
        v-if='showStreetField'
        cols='auto'
      >
        <label>{{ street }}</label>
      </w-column>
      <w-column
        v-if='showHouseNumberField'
        cols='auto'
      >
        <label>{{ houseNumber }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showZipCodeField || showCityField'>
      <w-column
        v-if='showZipCodeField'
        cols='auto'
      >
        <label>{{ zipCode }}</label>
      </w-column>
      <w-column
        v-if='showCityField'
        cols='auto'
      >
        <label>{{ city }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showStateField'>
      <w-column>
        <label>{{ state }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showCountryField'>
      <w-column cols='auto'>
        <label>{{ country }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showPhoneField'>
      <w-column>
        <label>{{ phone }}</label>
      </w-column>
    </w-row>
    <w-row v-if='showCommentField'>
      <w-column>
        <label>{{ comment }}</label>
      </w-column>
    </w-row>
    <slot
      name='append'
      :value-handed-and-filled='valueHandedAndFilled'
    />
  </div>
</template>

<script>
import readonlyMixin from "@/components/global_components/layout/readonly/readonly-mixin";

export default {
  name: "WorkAddressReadonlyLayout",
  mixins: [readonlyMixin],
  props: {
    withAdressTitle: { type: Boolean, default: true },
    removePadding: { type: Boolean, default: true },
    // fields
    company: { type: String, required: false },
    fullname: { type: String, required: false },
    street: { type: String, required: false },
    houseNumber: { type: String, required: false },
    supplement: { type: String, required: false },
    zipCode: { type: String, required: false },
    city: { type: String, required: false },
    state: { type: String, required: false },
    country: { type: String, required: false },
    phone: { type: String, required: false },
    comment: { type: String, required: false },
  },
  computed: {
    classes() {
      return {
        'w-readonly-layout': true,
        'w-adress-readonly-layout': true,
        'no-spacing': this.removePadding
      }
    },
    showCompanyField() {
      return this.valueHandedAndFilled(this.company);
    },
    showFullnameField() {
      return this.valueHandedAndFilled(this.fullname);
    },
    showStreetField() {
      return this.valueHandedAndFilled(this.street);
    },
    showHouseNumberField() {
      return this.valueHandedAndFilled(this.houseNumber);
    },
    showSupplementField() {
      return this.valueHandedAndFilled(this.supplement);
    },
    showZipCodeField() {
      return this.valueHandedAndFilled(this.zipCode);
    },
    showCityField() {
      return this.valueHandedAndFilled(this.city);
    },
    showStateField() {
      return this.valueHandedAndFilled(this.state);
    },
    showCountryField() {
      return this.valueHandedAndFilled(this.country);
    },
    showPhoneField() {
      return this.valueHandedAndFilled(this.phone);
    },
    showCommentField() {
      return this.valueHandedAndFilled(this.comment);
    },
  },
}
</script>

<style lang='scss' scoped>
@import "WReadonlyLayout";
</style>
